<!-- eslint-disable vue/valid-v-html -->
<template>
  <v-snackbar
    v-model="show"
    :timeout="timeout"
    :color="type"
    content-class="pr-0 py-0"
    rounded="lg"
    top
  >
    <v-container
      fluid
      fill-height
      class="pa-0"
    >
      <v-row
        no-gutters
      >
        <v-col
          class="py-3"
        >
          <div
            style="text-align: justify;"
            v-html="text"
          />
        </v-col>

        <v-col
          cols="1"
          class="d-flex justify-center py-0 pl-1"
          style="max-width: 30px;"
        >
          <v-divider
            vertical
          />
        </v-col>

        <v-col
          class="d-flex justify-center align-start py-3"
          style="max-width: 70px;"
        >
          <v-icon
            text
            @click="hidemsg"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>
    </v-container>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { sanitize } from '../../utils/validations';

export default {
  name: 'Snackbar',

  methods: {
    ...mapMutations([
      'setmsg',
      'hidemsg',
    ]),
  },

  computed: {
    ...mapGetters(['getmsg']),

    text() {
      return sanitize(this.getmsg.data.text);
    },

    type() {
      return this.getmsg.data.type;
    },

    timeout() {
      return this.getmsg.timeout;
    },

    show: {
      get() {
        return this.getmsg.show;
      },
      set(value) {
        this.setmsg(value);
      },
    },
  },
};
</script>
